import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import DocumentUtils from './document-utils';

@Injectable()
export class RenderingUtils {
    private renderer: Renderer2;
    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public initializeCollapsibleSections(): void {
        const intersectionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const collapsibleToggle = entry.target.querySelector('.collapsable-toggle') as HTMLElement;

                collapsibleToggle.classList.add('minus-black');
                if (!collapsibleToggle.dataset.listenerAdded) {
                    this.renderer.listen(collapsibleToggle, 'click', () => {
                        DocumentUtils.updateElementClass(collapsibleToggle, 'plus-black', 'minus-black');
                        this.toggleSectionVisibility(collapsibleToggle);
                    });
                    collapsibleToggle.dataset.listenerAdded = 'true'; // Mark as listener added
                }
            });
        });

        const observeCollapsableSection = () => {
            document.querySelectorAll('.collapsablesection').forEach((collapsablePanel) => {
                intersectionObserver.observe(collapsablePanel);
            });
        };
        observeCollapsableSection();

        const mutationObserver = new MutationObserver(() => {
            observeCollapsableSection(); // Re-observe if mutations occur
        });

        mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    private toggleSectionVisibility(e: HTMLElement): void {
        const sectionHeading = e.nextSibling;
        if (sectionHeading) {
            let sectionElement = sectionHeading.nextSibling as HTMLElement;
        
            while (sectionElement) {
                DocumentUtils.updateElementClass(sectionElement, 'collapsed', 'collapsable-body')
                sectionElement = sectionElement.nextSibling as HTMLElement;
            }
        }
    }

    initializeCollapsableNestedTable() {
        const intersectionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const listHeaderElements = entry.target.querySelectorAll('p.dita-p+ol.dita-ol');
                listHeaderElements.forEach(sectionElement => {
                    const sectionHeaderToggleElement = sectionElement.previousElementSibling as HTMLElement;
                    const sectionBody = sectionElement as HTMLElement;

                    sectionHeaderToggleElement.classList.add('cursor-pointer', 'arrow-down-white');

                    if (!sectionHeaderToggleElement.dataset.listenerAdded) {
                        this.renderer.listen(sectionHeaderToggleElement, 'click', () => {
                            if (sectionBody) {
                                DocumentUtils.updateElementClass(sectionBody, 'hidden');
                                DocumentUtils.updateElementClass(sectionHeaderToggleElement, 'arrow-down-white', 'arrow-right-white')
                            }
                        });
                        sectionHeaderToggleElement.dataset.listenerAdded = 'true'; // Mark as listener added
                    }
                });
            });
        });

        const observeCollapsableSection = () => {
            document.querySelectorAll('.collapsablesection > .dita-body > ol.dita-ol').forEach((collapsablePanel) => {
                intersectionObserver.observe(collapsablePanel);
            });
        };
        observeCollapsableSection();

        const mutationObserver = new MutationObserver(() => {
            observeCollapsableSection(); // Re-observe if mutations occur
        });

        mutationObserver.observe(document.body, { childList: true, subtree: true });

    }
    
}